var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar27(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_50_Kids_Icons-28",
    "data-name": "50_Kids_Icons-28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z",
    fill: "#3d2a3d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4524",
    "data-name": "Group 4524"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4523",
    "data-name": "Group 4523",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4514",
    "data-name": "Group 4514",
    transform: "translate(22.819 37.951)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M152.761,246.493c1.025,2.428.467,4.787-1.247,5.27s-3.933-1.093-4.958-3.521-.467-4.787,1.247-5.27S151.736,244.065,152.761,246.493Z",
    transform: "translate(-146.043 -242.885)",
    fill: "#f0b39c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M319.815,246.492c-1.025,2.428-.467,4.787,1.247,5.27s3.933-1.093,4.958-3.521.467-4.787-1.247-5.27S320.84,244.065,319.815,246.492Z",
    transform: "translate(-292.23 -242.885)",
    fill: "#f0b39c"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_96",
    "data-name": "Ellipse 96",
    cx: 17.969,
    cy: 16.449,
    rx: 17.969,
    ry: 16.449,
    transform: "translate(22.002 13.485)",
    fill: "#a14b2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M128.212,412.258l-.008-.132c0-8-3-15.753-6.652-17.229l-15.575-6.275a20.633,20.633,0,0,0-13.3-.017l-15.8,6.312c-3.66,1.465-6.655,9.208-6.655,17.209l-.008.132Z",
    transform: "translate(-59.241 -326.964)",
    fill: "#f0b39c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M226.793,277.007a6.219,6.219,0,0,1-6.219,6.219h-.754a6.219,6.219,0,0,1-6.219-6.219V260.989a6.219,6.219,0,0,1,6.219-6.219h.754a6.219,6.219,0,0,1,6.219,6.219Z",
    transform: "translate(-180.227 -214.962)",
    fill: "#f0b39c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4515",
    "data-name": "Group 4515",
    transform: "translate(25.162 18.42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M190.653,141.985a15.048,15.048,0,0,1-14.807,15.289h0a15.049,15.049,0,0,1-14.812-15.289v-8.813a15.055,15.055,0,0,1,14.812-15.287h0a15.054,15.054,0,0,1,14.807,15.287Z",
    transform: "translate(-161.034 -117.885)",
    fill: "#ffdbc5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4516",
    "data-name": "Group 4516",
    transform: "translate(33.292 41.491)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_97",
    "data-name": "Ellipse 97",
    cx: 1.548,
    cy: 1.548,
    r: 1.548,
    fill: "#2961a5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_98",
    "data-name": "Ellipse 98",
    cx: 1.548,
    cy: 1.548,
    r: 1.548,
    transform: "translate(10.263)",
    fill: "#2961a5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4517",
    "data-name": "Group 4517",
    transform: "translate(24.26 18.08)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M170.975,115.709c-8.677,0-15.711,7.624-15.711,17.029a18.05,18.05,0,0,0,2.13,8.566l1.561-13.238h24.037l1.564,13.239a18.051,18.051,0,0,0,2.13-8.566C186.686,123.333,179.652,115.709,170.975,115.709Z",
    transform: "translate(-155.264 -115.709)",
    fill: "#a14b2a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M244.244,279.542a2.384,2.384,0,0,1-4.653.538,2.526,2.526,0,0,0-.114.71,2.553,2.553,0,1,0,5.105,0A2.516,2.516,0,0,0,244.244,279.542Z",
    transform: "translate(-202.059 -235.864)",
    fill: "#f0b39c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M128.2,425.067c0-8-2.995-15.753-6.652-17.229l-12.384-4.989a10.937,10.937,0,0,1-19.889.053l-12.4,4.956c-3.66,1.465-6.655,9.208-6.655,17.209l-.008.132h58Z",
    transform: "translate(-59.241 -339.904)",
    fill: "#a18fa1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4520",
    "data-name": "Group 4520",
    transform: "translate(31.377 37.572)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4518",
    "data-name": "Group 4518"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M202.053,242.777a7.11,7.11,0,0,1,3.356-.68.817.817,0,0,0,0-1.633,8.857,8.857,0,0,0-4.18.9c-.942.47-.115,1.879.824,1.41Z",
    transform: "translate(-200.814 -240.461)",
    fill: "#bf642c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4519",
    "data-name": "Group 4519",
    transform: "translate(11.802)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M280.494,242.777a7.109,7.109,0,0,0-3.356-.68.817.817,0,0,1,0-1.633,8.856,8.856,0,0,1,4.18.9c.942.47.115,1.879-.824,1.41Z",
    transform: "translate(-276.349 -240.461)",
    fill: "#bf642c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4521",
    "data-name": "Group 4521",
    transform: "translate(23.536 27.322)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M161.878,179.4c0,2.508-2.517,4.541-5.622,4.541s-5.623-2.033-5.623-4.541,2.518-4.541,5.623-4.541S161.878,176.893,161.878,179.4Z",
    transform: "translate(-150.633 -174.86)",
    fill: "#bf642c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M231.076,179.4c0,2.508-2.517,4.541-5.623,4.541s-5.622-2.033-5.622-4.541,2.517-4.541,5.622-4.541S231.076,176.893,231.076,179.4Z",
    transform: "translate(-209.019 -174.86)",
    fill: "#bf642c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_99",
    "data-name": "Ellipse 99",
    cx: 5.622,
    cy: 4.541,
    rx: 5.622,
    ry: 4.541,
    transform: "translate(21.625)",
    fill: "#bf642c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4522",
    "data-name": "Group 4522",
    transform: "translate(34.465 47.827)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M229.325,306.458a4.883,4.883,0,0,1-6.487,0c-1.231-1.159-3.091.694-1.856,1.856a7.56,7.56,0,0,0,10.2,0c1.235-1.162-.625-3.015-1.856-1.856Z",
    transform: "translate(-220.575 -306.091)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar27);
export default __webpack_public_path__ + "static/media/avatar27.82da2a74824a7d048ed0bc182ba5fc26.svg";
export { ForwardRef as ReactComponent };